export default __webpack_public_path__ + "static/media/Rubik-Medium.5daa89aa.ttf";